export function byteToString(arr) {
    if(typeof arr === 'string') {
        return arr;
    }
    var str = '',
        _arr = arr;
    for(var i = 0; i < _arr.length; i++) {
        var one = _arr[i].toString(2),
            v = one.match(/^1+?(?=0)/);
        if(v && one.length == 8) {
            var bytesLength = v[0].length;
            var store = _arr[i].toString(2).slice(7 - bytesLength);
            for(var st = 1; st < bytesLength; st++) {
                store += _arr[st + i].toString(2).slice(2);
            }
            str += String.fromCharCode(parseInt(store, 2));
            i += bytesLength - 1;
        } else {
            str += String.fromCharCode(_arr[i]);
        }
    }
    return str;
}

//小数点3位逗号分隔,实时输入
export function  formatThree(value){
    if(value==null||value=="null") {
        return
    }
    value = value.toString()
    if(/[^\d\.]/.test(value)){
        value=value.replace(/[^\d\.-]/g,'');
    }
    var num = value.split(".")[0];
    var decimal = "";

    if(value.indexOf(".") >= 0){
        decimal = "." + value.split(".")[1];
    }

    var result = num.replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,');
    result += decimal==undefined?"":decimal;
    return result
}
export function formatNum(num,currency) {
    if(!/^(\+|-)?(\d+)(\.\d+)?$/.test(num)){
        // alert("wrong!");
        return   num;
    }
    var a = RegExp.$1, b = RegExp.$2, c = RegExp.$3;
    var re = new RegExp().compile("(\\d)(\\d{3})(,|$)");
    while(re.test(b)) b = b.replace(re,   "$1,$2$3");
    if(currency&&(currency!='JPY'&&currency!='IDR')){
        c = c == ''?'.00':c;
    }
    return a +""+ b +""+ c;
}
// 获取当前时间 YYYY-MM-DD hh:mm:ss格式的时间
export function getNowFormatDate(date) {
    var date = date ? new Date(date) : new Date();
    var seperator1 = "-";
    var seperator2 = ":";
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    if (hours >= 0 && hours <= 9) {
      hours = "0" + hours;
    }
    if (minutes >= 0 && minutes <= 9) {
      minutes = "0" + minutes;
    }
    if (seconds >= 0 && seconds <= 9) {
      seconds = "0" + seconds;
    }
    
    var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate +
      " " + hours + seperator2 + minutes + seperator2 + seconds;
    return currentdate;
  }
  // 转化数字金钱化
  export function fmoney(s, n = 3) {
    if(!s) return s
    s=(s).toString()
    n = n >= 0 && n <= 20 ? n : 2;
    var arr = []
    if(s.indexOf('.')!=-1){
      arr = s.split(".")
      s = arr[0]+(n==0?'':'.')+(n==0?'':((('0.'+arr[1])*1).toFixed(n).toString().split('.')[1]))+''
    }else{
      s = s+(n==0?'':'.')+(n==0?'':('0').repeat(n));
    }
    let l = s.split(".")[0],
      r = s.split(".")[1],
      t = l.replace(/(?=(\B)(\d{3})+$)/g,',')
    r = r ? `.${r}` : ''
    return t + r;
  }
  //货币格式转换成数值
  export function moneyToNumValue(val) {
    var num = val.trim();
    var ss = num.toString();
    if (ss.length == 0) {
      return "0";
    }
    return ss.replace(/,/g, "");
  }
  // 获取几个月后的时间戳
  /*
      @param {number} num 数字代表几个月之后 如果不输入返回当前时间戳
  */
  export function futuremon(num) {
    let data = new Date()
    let nowtime = data.getTime()
    if (num !== undefined) {
      let year = data.getFullYear()
      let month = data.getMonth() + num
      let day = data.getDate()
      let date = new Date(year, month, day)
      let time = date.getTime()
      return time
    } else {
      return nowtime
    }

  }
  // 时间戳转化成yyyymmddhhmmss的时间
  export function formatDateTimes(inputTime) {
    if(!inputTime) return inputTime;
    var date = new Date(inputTime);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    var d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    var h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    var minute = date.getMinutes();
    var second = date.getSeconds();
    minute = minute < 10 ? ('0' + minute) : minute;
    second = second < 10 ? ('0' + second) : second;
    return ''+y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
  }
  // 时间戳转化成yyyy-mm-dd的时间
  export function formatDateTime(inputTime) {
    if(!inputTime) return inputTime;
    var date = new Date(inputTime);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    var d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    var h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    var minute = date.getMinutes();
    var second = date.getSeconds();
    minute = minute < 10 ? ('0' + minute) : minute;
    second = second < 10 ? ('0' + second) : second;
    return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
  }
  // 时间戳转化成yyyy-mm-dd的时间
  export function formatDateTime3(inputTime) {
    if(!inputTime) return inputTime;
    var date = new Date(inputTime);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    var d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    var h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    var minute = date.getMinutes();
    var second = date.getSeconds();
    minute = minute < 10 ? ('0' + minute) : minute;
    second = second < 10 ? ('0' + second) : second;
    return y + '-' + m + '-' + d;
  }
  // 时间戳转化成yyyy-mm的时间
  export function formatDateTime2(inputTime) {
    if(!inputTime) return inputTime;
    var date = new Date(inputTime);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    return y + '-' + m ;
  }
  // 时间戳转化成yyyy-mm-dd的时间
  export function formatDate(inputTime) {
    if(!inputTime) return inputTime;
    var date = new Date(inputTime);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    var d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    var h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    var minute = date.getMinutes();
    var second = date.getSeconds();
    minute = minute < 10 ? ('0' + minute) : minute;
    second = second < 10 ? ('0' + second) : second;
    return y + '-' + m + '-' + d;
  }
  export function exportJPG(file, fileName) {
    let userAgent = window.navigator.userAgent
    const blob = new Blob([file], {
        type: "image/jpeg"
    })
    if (userAgent.indexOf('Edge')==-1&&userAgent.indexOf('Trident')==-1) { // 非IE下载
      const elink = document.createElement('a')
      elink.download = fileName+'.jpg'
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    } else {
      navigator.msSaveBlob(blob, fileName+'.jpg')
    }
  }
  export function exportPDF(file, fileName) {
    let userAgent = window.navigator.userAgent
    const blob = new Blob([file], {
      type: "application/pdf"
    })
    if (userAgent.indexOf('Edge')==-1&&userAgent.indexOf('Trident')==-1) { // 非IE下载
      const elink = document.createElement('a')
      elink.download = fileName+'.pdf'
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    } else { // IE10+下载
      // var elemIF = document.createElement("iframe");
      // elemIF.src = blob;
      // elemIF.style.display = "none";
      //  document.body.appendChild(elemIF);
      console.log('IE')
      navigator.msSaveBlob(blob, fileName+'.pdf')
    }
  }
  export function  preViewPDF(file, fileName) {
    let userAgent = window.navigator.userAgent
    const blob = new Blob([file], {
      type: "application/pdf;charset=UTF-8"
    })
    if (userAgent.indexOf('Edge')==-1&&userAgent.indexOf('Trident')==-1) { // 非IE下载
      const elink = document.createElement('a')
      elink.target = "_blank"
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      setTimeout(()=>{
        document.body.removeChild(elink)
      },1000)
    } else { // IE10+下载
       window.navigator.msSaveOrOpenBlob(blob, fileName+'.pdf')
    }
  }
  // 验证码
  export function timeOver(form){
    let time=60;
    let str='s后重新发送';
    form.text=`${time}${str}`;
    form.status=true;
    let t=setInterval(function () {
        --time;
        form.text=`${time}${str}`;
    },1000);
    setTimeout(function () {
        clearInterval(t);
        form.text="获取验证码";
        form.status=false;
    },60000);
}

  export function downloadfile(file, fileName) {
    let userAgent = window.navigator.userAgent
    const blob = new Blob([file], {
      type: "application/vnd.ms-excel"
    })
    if (userAgent.indexOf('Edge')==-1&&userAgent.indexOf('Trident')==-1) { // 非IE下载
      const elink = document.createElement('a')
      elink.download = fileName+'.xls'
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    } else { // IE10+下载
      // var elemIF = document.createElement("iframe");
      // elemIF.src = blob;
      // elemIF.style.display = "none";
      //  document.body.appendChild(elemIF);
      console.log('IE')
      navigator.msSaveBlob(blob, fileName+'.xls')
    }
  }

  export function downloadfilexlsx(file, fileName) {
    let userAgent = window.navigator.userAgent
    const blob = new Blob([file], {
      type: "application/vnd.ms-excel"
    })
    if (userAgent.indexOf('Edge')==-1&&userAgent.indexOf('Trident')==-1) { // 非IE下载
      const elink = document.createElement('a')
      elink.download = fileName+'.xlsx'
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    } else { // IE10+下载
      // var elemIF = document.createElement("iframe");
      // elemIF.src = blob;
      // elemIF.style.display = "none";
      //  document.body.appendChild(elemIF);
      console.log('IE')
      navigator.msSaveBlob(blob, fileName+'.xlsx')
    }
  }
  export function anyTypefile(file, fileName) {
    let userAgent = window.navigator.userAgent
    const blob = new Blob([file], {
      type: "application/octet-stream"
    })
    if (userAgent.indexOf('Edge')==-1&&userAgent.indexOf('Trident')==-1) { // 非IE下载
      const elink = document.createElement('a')
      elink.download = fileName
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    } else { // IE10+下载
      // var elemIF = document.createElement("iframe");
      // elemIF.src = blob;
      // elemIF.style.display = "none";
      //  document.body.appendChild(elemIF);
      console.log('IE')
      navigator.msSaveBlob(blob, fileName)
    }
  }
  export function downloadfileOns(file, fileName) {
    let userAgent = window.navigator.userAgent
    const blob = new Blob([file], {
      type: "application/vnd.ms-excel;charset=UTF-8"
    })
    if (userAgent.indexOf('Edge')==-1&&userAgent.indexOf('Trident')==-1) { // 非IE下载
      const elink = document.createElement('a')
      elink.download = fileName+'.xls'
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    } else { // IE10+下载
      navigator.msSaveBlob(blob, fileName+'.xls')
    }
  }
  export function downloadZip(file, fileName) {
    let userAgent = window.navigator.userAgent
    const blob = new Blob([file], {
      type: "application/zip"
    })
    if (userAgent.indexOf('Edge')==-1&&userAgent.indexOf('Trident')==-1) { // 非IE下载
      const elink = document.createElement('a')
      elink.download = fileName+'.zip'
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    } else { // IE10+下载
      navigator.msSaveBlob(blob, fileName+'.zip')
    }
  }
  // 转化时间格式
  export function timeFordat(time) {
    return time.split('-').join('')
  }
  // 转化时间显示格式
  export function showtime(time) {
    return String.raw({
      raw: time
    }, '', '', '', '-', '', '-')
  }
  // 返回固定位数的随机数
  export function random(num) {
    var str = ''
    for (var i = 0; i < num; i++) {
      str += Math.floor(Math.random() * 10)
    }
    return str
  }
  // 返回不同币种的精确值
  export function currencynum(str) {
    let num = ''
    JSON.parse(localStorage.current).forEach((item) => {
      if (item.alphaCode == str) {
        num = item.minorUnit
      }
    })
    return num
  }

  function getExplorer() {
    var explorer = window.navigator.userAgent;
    //ie
    if (explorer.indexOf("Trident") >= 0||explorer.indexOf("Edge") >= 0) {
      return 'ie';
    }
    //firefox
    else if (explorer.indexOf("Firefox") >= 0) {
      return 'Firefox';
    }
    //Chrome
    else if (explorer.indexOf("Chrome") >= 0) {
      return 'Chrome';
    }
    //Opera
    else if (explorer.indexOf("Opera") >= 0) {
      return 'Opera';
    }
    //Safari
    else if (explorer.indexOf("Safari") >= 0) {
      return 'Safari';
    }
  }
  export function ExportExcel(tableid) { //整个表格拷贝到EXCEL中
    if (getExplorer() == 'ie') {
      console.log('ie')
      var curTbl = document.getElementById(tableid);
      var oXL = new ActiveXObject("Excel.Application");
      var oWB = oXL.Workbooks.Add();
      var xlsheet = oWB.Worksheets(1);
      var sel = document.body.createTextRange();
      sel.moveToElementText(curTbl);
      sel.select();
      sel.execCommand("Copy");
      xlsheet.Paste();
      oXL.Visible = true;

      try {
          var fname = oXL.Application.GetSaveAsFilename("Excel.xls", "Excel Spreadsheets (*.xls), *.xls");
      } catch (e) {
          print("Nested catch caught " + e);
      } finally {
          oWB.SaveAs(fname);
          oWB.Close(savechanges = false);
          oXL.Quit();
          oXL = null;
          idTmr = window.setInterval("Cleanup();", 1);
      }
    } else {
      tableToExcel(tableid);
    }
  }

  function Cleanup() {
    window.clearInterval(idTmr);
    CollectGarbage();
  }
  var tableToExcel = (function () {
    var uri = 'data:application/vnd.ms-excel;base64,',
      template = '<!DOCTYPE html><html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
      base64 = function (s) {
        return window.btoa(unescape(encodeURIComponent(s)))
      },
      format = function (s, c) {
        return s.replace(/{(\w+)}/g,
          function (m, p) {
            return c[p];
          })
      }
    return function (table, name) {
      if (!table.nodeType) table = document.getElementById(table)
      var ctx = {
        worksheet: name || 'Worksheet',
        table: table.innerHTML
      }
      window.location.href = uri + base64(format(template, ctx))
    }
  })()
  /*将100000转为100,000.00形式*/
  export function conversionNumber(money) {
    if (money && money != null) {
      money = String(money);
      var left = money.split('.')[0],
        right = money.split('.')[1];
      right = right ? (right.length >= 2 ? '.' + right.substr(0, 2) : '.' + right + '0') : '.00';
      var temp = left.split('').reverse().join('').match(/(\d{1,3})/g);
      return (Number(money) < 0 ? "-" : "") + temp.join(',').split('').reverse().join('') + right;
    } else if (money === 0) { //注意===在这里的使用，如果传入的money为0,if中会将其判定为boolean类型，故而要另外做===判断
      return '0.00';
    } else {
      return "";
    }
  }
  /*将100,000.00转为100000形式*/
  export function undoNubmer(money) {
    if (money && money != null) {
      money = String(money);
      var group = money.split('.');
      var left = group[0].split(',').join('');
      return Number(left + "." + group[1]);
    } else {
      return "";
    }
  }


  // 找出当前元素下的指定子元素
  export function findC(curEle,tagName){
    var nodeList = curEle.childNodes;
    var ary = [];
    var curTag;
    if(/MSIE(6|7|8)/.test(navigator.userAgent)){
        for(var i=0;i<nodeList.length;i++){
            var curNode = nodeList[i];
            if(curNode.nodeType ===1){
               ary[ary.length] = curNode;
            }
        }
    }else{
        ary = Array.prototype.slice.call(curEle.children);
    }

    // 获取指定子元素
    if(typeof tagName === "string"){
        for(var k=0;k<ary.length;k++){
          curTag = ary[k];
          if(curTag.nodeName.toLowerCase() !== tagName.toLowerCase()){
           ary.splice(k,1);
           k--;
          }
        }
    }

    return ary;
  }
  export function getJSON(url, callback){
    if(window.XMLHttpRequest){
        var xhr=new XMLHttpRequest();
    }else{
        var xhr=new ActiveXObject("Microsoft.XMLHTTP");
    };
    xhr.open("GET",url);
    xhr.setRequestHeader("Content-type","application/x-www-form-urlencoded");
    xhr.send();
    xhr.onreadystatechange=function(){
        if(xhr.readyState==4 && xhr.status==200){
            var data=xhr.responseText;
            data=JSON.parse(data);
            callback(data)
        };
    };
  };

  //转币种符号
  export function toSign(cs){
    switch(cs) {
      case "USD":
        return "$"
      case "EUR":
        return "€"
      case "GBP":
        return "￡"
      case "JPY":
        return "¥"
      case "CNY":
        return "￥"
      case "AUD":
        return "A$"
      case "CAD":
        return "C$"
      case "HKD":
        return "HK$"
      case "SGD":
        return "$"
      case "NZD":
        return "NZ$"
      case "CHF":
        return "Fr"
      case "AED":
        return "AED"
      case "SAR":
        return "SAR"
    }
  };

  //英转中
  export function toAb(cs){
    switch(cs) {
      case "USD":
        return "美元"
      case "EUR":
        return "欧元"
      case "GBP":
        return "英镑"
      case "JPY":
        return "日元"
      case "CNY":
        return "人民币"
      case "CNH":
        return "离岸人民币"
      case "AUD":
        return "澳元"
      case "CAD":
        return "加元"
      case "HKD":
        return "港币"
      case "SGD":
        return "新加坡元/新币"
      case "NZD":
        return "新西兰元"
      case "CHF":
        return "瑞士法郎"
      case "AED":
        return "迪拉姆"
      case "SAR":
          return "沙特里亚尔"
      case "MYR":
          return "马来西亚吉林特"
      case "THB":
          return "泰铢"
      case "PHP":
          return "菲律宾比索"
      case "INR":
          return "印度卢比"
      case "VND":
          return "越南盾"
    }
  };

  //币种转图标
  export function toCountryIcon(value){
    switch(value){
      case "GBP":
        return "../../../static/images/nationalFlag/GBP.png"
      case "EUR":
          return "../../../static/images/nationalFlag/EUR.png"
      case "USD":
          return "../../../static/images/nationalFlag/USD.png"
      case "AUD":
          return "../../../static/images/nationalFlag/AUD.png"
      case "CAD":
          return "../../../static/images/nationalFlag/CAD.png"
      case "CHF":
          return "../../../static/images/nationalFlag/CHF.png"
      case "HKD":
          return "../../../static/images/nationalFlag/HKD.png"
      case "CNY":
          return "../../../static/images/nationalFlag/CNY.png"
      case "CNH":
          return "../../../static/images/nationalFlag/CNY.png"
      case "JPY":
          return "../../../static/images/nationalFlag/JPY.png"
      case "NZD":
          return "../../../static/images/nationalFlag/NZD.png"
      case "SGD":
          return "../../../static/images/nationalFlag/SGD.png"
      case "AED":
          return "../../../static/images/nationalFlag/AED.png"
      case "MYR":
          return "../../../static/images/nationalFlag/MYR.png"
      case "PHP":
          return "../../../static/images/nationalFlag/PHP.png"
      case "INR":
          return "../../../static/images/nationalFlag/INR.png"
      case "THB":
          return "../../../static/images/nationalFlag/THB.png"
      case "VND":
          return "../../../static/images/nationalFlag/VND.png"
    }
};

export function getOpenApiDocUrl(){
    var url = ""
    var host = location.host;
    if(host.indexOf('localhost')!=-1 || host.indexOf('172.') != -1) {
        url = "https://openapi1.dev.ipaylinks.com/doc.html#/home"
    }
    //开发
    else if(host.indexOf('dev')!=-1) {
        url = "https://openapi1.dev.ipaylinks.com/doc.html#/home"
    }
    //测试一套
    else if(host.indexOf('mp1.sit')!=-1){
        url = "https://openapi1.sit.ipaylinks.com/doc.html#/home"
    }
    //测试二套
    else if(host.indexOf('mp2.sit')!=-1){
        url = "https://openapi2.sit.ipaylinks.com/doc.html#/home"
    }
    //测试三套
    else if(host.indexOf('mp3.sit')!=-1){
        url = "https://openapi3.sit.ipaylinks.com/doc.html#/home"
    }
    //测试四套
    else if(host.indexOf('mp4.sit')!=-1){
        url = "https://openapi4.sit.ipaylinks.com/doc.html#/home"
    }
    //联调
    else if(host.indexOf('uat')!=-1){
        url = "https://openapi1.uat.ipaylinks.com/doc.html#/home"
    }
    //aws预发1
    else if(host.indexOf('mp1.pre')!=-1){
        url = "https://openapi1.pre.ipaylinks.com/doc.html#/home"
    }
    //aws预发2
    else if(host.indexOf('mp2.pre')!=-1){
        url = "https://openapi2.pre.ipaylinks.com/doc.html#/home"
    }
    else {
        url = "https://openapi.ipaylinks.com/doc.html#/home"
    }
    return url;
}
